import { bus } from "../../main.js";

const emitTextClicked = ({ rootGetters }, index) => {
  bus.$emit(
    "document-text-clicked",
    rootGetters['documents/taggedText'][rootGetters['documents/currentPage'] - 1][index].word
  );
};

export const actions = {
  emitTextClicked,
};
const mutations = {}
const getters = {}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
}